import React from 'react';
import component from './component';

export const CursorInput = component('CursorInput', function({value, onChange, ...props}) {
  const changeHandler = (e) => {
    onChange && onChange(e);
    value.set(e.target.value);
  }
  return (
    <input {...props} value={value.deref()} onChange={changeHandler} />
  );
});

export const CursorTextarea = component('CursorTextarea', function({value, onChange, ...props}) {
  const changeHandler = (e) => {
    onChange && onChange(e);
    value.set(e.target.value);
  }
  return (
    <textarea {...props} value={value.deref()} onChange={changeHandler} />
  );
});

export default component('Form', function({data}) {
  return (
    <div className='Form'>
      <CursorInput value={data.cursor('foo')} />
      <CursorInput value={data.cursor('bar')} />
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/Form.js